import "./HomeStyle.css";
import "./HeroStyle.css";
import React, { useEffect, useRef } from "react";
import Typed from "typed.js";
// import webpage from "../../assets/images/webpage.jpg";
import Subscribe from "../../subscribe/Subscribe";
import { HeroComponent } from "./HeroComponent";

const HomeComponent = () => {
  // const { user } = useAuthContext();

  return (
    <>
      <section className="home">
        <HeroComponent />
        <div className="home-hero vh-100 d-none">
          <div className="container">
            <div className="row mt-4">
              <div className="col"></div>
              {/* <div className="col right-image d-none d-lg-block d-xl-block"></div> */}
            </div>
          </div>
        </div>
        {/* Subscribe component */}
        <Subscribe />
      </section>
    </>
  );
};

export default HomeComponent;
